import { HttpClient } from '@angular/common/http';
import { Component, Injectable, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { LoginService } from 'src/app/_services/login.service';
import { PasswordStrengthValidator } from 'src/app/Product/password-strength.validators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {

  constructor(
    private loginService: LoginService,
    private authService: AuthService,
    private router: Router,
    private http: HttpClient,
    public alertService: AlertService,
    private sanitizer: DomSanitizer,
    private cookieService: CookieService
  ) { }

  csrfToken: string;
  isLoading: boolean = false;

  ngOnInit(): void {
    const rememberMeData = this.authService.getRememberMe();
    if (rememberMeData) {
      this.loginForm = new FormGroup(
        {
          UserName: new FormControl(rememberMeData.username),
          Password: new FormControl(rememberMeData.password),
          //csrf: new FormControl(''),
          rememberMe: new FormControl(true)
        }
      )
    }
  }
  submitted: boolean = true;
  hide = true;
  message: boolean = false;
  dangerMessage: boolean = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };

  loginForm: FormGroup = new FormGroup(
    {
      UserName: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      Password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
        PasswordStrengthValidator]),
      csrf: new FormControl(''),
      rememberMe: new FormControl(false)
    }
  )

  login() {
    const link = environment.navigation + 'vendorChangePass';
    this.submitted = true;
    this.isLoading = true;
    this.loginService.login(this.loginForm.value)
      .subscribe((response: any) => {
        this.cookieService.set('Token', response.token);
        this.authService.setTokenDetails(response);
        this.authService.setToken(response.token);
        console.log(response);
        this.loginService.details(response.token)
          .subscribe((response: any) => {
            console.log(response)
            if (response.userType == 'Vendor') {
              if (response.isFirstTimeLogin == true) {
                window.location.href = link;
              }
              else {
                window.location.href = environment.navigation + 'mainDashboard';
              }
            }
            else {
              this.authService.setRegistredUserDetails(response);
              //this.loginService.updateProfile(response, response.token);
              console.log("det :", response);
              const isactive = response.isActive;
              this.alertService.success('Success!!', this.options);
              console.log('Login Successful');
              this.isLoading = false;
              this.router.navigate(response.isActive ? ['/All/dashboardCompo'] : ['/inactiveAll/inactiveUser']);
            }
          }, (err) => {
            console.log(err);
            this.isLoading = false;
            // this.alertService.error(err.error.errors.Messages[0], this.options);
            this.alertService.error(err.error.error, this.options);
          })
      }, (error) => {
        this.isLoading = false;
        // this.alertService.error(error.error.errors.Messages[0], this.options);
        this.alertService.error(error.error.error, this.options);
        console.log(error);
      });

    if (this.loginForm.value.rememberMe) {
      this.authService.setRememberMe(this.loginForm.value.UserName, this.loginForm.value.Password);
    }
  }

  get forms() { return this.loginForm.controls; }

  get sanitizedCsrfToken() {
    return this.sanitizer.bypassSecurityTrustHtml(this.loginForm.value.csrf);
  }
}
